import 'react-dropdown-tree-select/dist/styles.css'
import {useState} from "react";
import DropdownTreeSelect from 'react-dropdown-tree-select';

export default function DropdownTree({data = [], label = "", unselectAllHandler, onClose, ...otherProps}) {

    const [showDropDown, setShowDropDown] = useState(false);

    const closeHandler = () => {
        setShowDropDown(false)
        if (typeof onClose === "function") {
            onClose()
        }
    }

    return (
        <div className="relative w-full">
            <div
                className={`w-screen h-screen fixed left-0 top-0 z-20 ${showDropDown ? "" : "hidden"}`}
                onClick={closeHandler}/>

            <button
                onClick={() => setShowDropDown(true)}
                type="button"
                className="w-full rounded-2xl bg-pol-light-7 p-3.5 border border-pol-gray-light-3 flex items-center justify-between text-pol-dark-800">
                <p className="font-semibold">{label}</p>
                <i className="icon-simple-arrow-left block -rotate-90 text-sm"/>
            </button>
            <div
                className={`absolute z-20 w-full h-[18.125rem] bg-white rounded-2xl top-0 left-0 shadow-[0_0_9px_11px_rgba(142,130,180,0.06)] overflow-y-scroll pol-scroll px-3.5 pt-3 pb-0 ${showDropDown ? "" : "hidden"}`}>
                <DropdownTreeSelect
                    texts={{
                        placeholder: "جستجو...",
                        noMatches: "موردی پیدا نشد"
                    }}
                    showDropdown="always"
                    className="pol-dropdown-tree"
                    data={data}
                    {...otherProps} />

                <div
                    className="bg-white w-full h-9 sticky top-[calc(100%-36px)] left-0 flex-center z-10 font-semibold text-pol-red">
                    <button type="button" className="flex items-center" onClick={unselectAllHandler}>
                        <i className="icon-trash ml-2.5"/>
                        <span className="">حذف فیلتر</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
